import Axios from "api/axios"
import env from 'global/environments'
import React, { useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import Router from './router/Router'
import Error from './views/error/500'

import { store } from 'redux/storeConfig/store'
import { connect } from "react-redux"
import { settingsUpdateContentWidth } from 'redux/actions/settings'

function ErrorFallback({ error, resetErrorBoundary }) {
  return <Error />
}

const myErrorHandler = async (error, info) => {
  await Axios({
    withCredentials: true,
    method: 'POST',
    url: '/client/error',
    data: {
      env,
      store: store.getState(),
      error,
      info,
    }
  })
}

const App = (props) => {
  // const { settingsUpdateContentWidth } = props;
  useEffect(() => {
    // if (env.platform === 'enterprise') settingsUpdateContentWidth('full')
  })
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={myErrorHandler}>
      <Router />
    </ErrorBoundary>
  )
}

export default connect(null, { settingsUpdateContentWidth })(App)
